module.exports = __webpack_public_path__ + "static/media/trash.19412dc7.svg";